export default __webpack_public_path__ + "static/media/img_paloalto-colorBkg.58a8d547.png";